export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-secondary-900 text-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-black">
              <span className="text-primary-400">51</span>
              <span className="text-accent-400">黑料吃瓜网</span>
            </span>
            <p className="text-sm text-secondary-300 mt-3 leading-relaxed">
              国内领先的娱乐资讯聚合平台，提供51吃瓜轻量版APP下载，支持安卓版一键安装。7x24小时追踪娱乐圈动态，最新入口同步更新，随时随地吃瓜更便捷。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">快速导航</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: '实时快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点深扒', href: '#carousel' },
                { label: '吃瓜热度榜', href: '#ranking' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-sm text-secondary-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">APP下载</h4>
            <ul className="flex flex-col gap-2">
              {[
                { label: '51吃瓜轻量版', href: '#app' },
                { label: '安卓版安装包', href: '#app' },
                { label: '安装帮助', href: '#faq' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNavClick(link.href);
                    }}
                    className="text-sm text-secondary-300 hover:text-accent-400 transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-400 leading-relaxed">
              更多合作伙伴即将入驻，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} 51黑料吃瓜网 - 51吃瓜轻量版APP下载 | 黑料吃瓜安卓版 | 51吃瓜app安装
          </p>
          <p className="text-xs text-secondary-500">
            本站内容仅供娱乐参考，不构成任何建议
          </p>
        </div>
      </div>
    </footer>
  );
}